import { Theme } from "@mui/material/styles";

export const textFieldStyles = (theme: Theme) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: "12px",
    fontSize: "0.875rem",
    boxShadow: "rgba(99, 99, 99, 0.1) 0px 2px 4px 0px",
    minHeight: "45px",
    "& input": {
      padding: "12px",
    },
    "& textarea": {
      padding: "12px",
    },
    "& fieldset": {
      borderWidth: "1px",
      borderColor:
        theme.palette.mode === "light"
          ? "#e0e0e0"
          : "rgba(255, 255, 255, 0.23)",
    },
  },
  "& .MuiFormHelperText-root": {
    fontSize: "0.75rem",
    marginLeft: 0,
  },
});
